import RootStore from './RootStore';
import videoApi from '../actions/video';
import { IGalleryStatus, IResult } from '../global.d';
import { observable, action, computed } from 'mobx';

export interface IMedium {
  id: number;
  type: string;
  source: string;
  source_detail?: ILiveSource;
  desc: string;
  status: string;
  gallery_id?: number;
  view?: number;
  uv?: number;
  thumb: string;
  options: string;
}

export interface IMediumOptions {
  cutter_id?: string;
  width?: string | number;
  height?: string | number;
  duration?: string | number;
  file_size?: string | number;
}

export interface ILiveSource {
  id: number;
  title: string;
  cover_img: string;
  gallery_id: number;
  play_url: string;
  play_back_url?: string;
  cut_play_url?: string;
  status: IGalleryStatus;
  second_url?: string;
  filter_option?: string;
  begin_at: string;
  end_at: string;
}

export interface IMediumMap {
  [key: string]: IMedium;
}

interface ILiveCutResult {
  items: IMedium[];
  total?: number;
  nomore?: boolean;
  message?: string;
}

export default class IMStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @observable list = {} as IMediumMap;
  @observable liveshow_list = {
    items: [],
    total: -1,
  } as {
    items: IMedium[];
    total: number;
  };

  @observable liveshow_search = {
    items: [],
    total: -1,
  } as {
    items: IMedium[];
    total: number;
  };

  @observable livecut_list = {

  } as {
    [key:string]:ILiveCutResult
  }
  // @observable livecut_list = {
  //   items: [],
  //   total: -1,
  // } as ILiveCutResult

  @observable livecut_search = {

  } as {
    [key:string]:ILiveCutResult
  }
  // @observable livecut_search = {
  //   items: [],
  //   total: -1,
  // } as {
  //   items: IMedium[];
  //   total: number;
  // };

  @computed get views() {
    let view = 0;
    Object.keys(this.list).forEach((key: string) => {
      let it = this.list[String(key)] as IMedium;
      if (it && it.view) {
        view += Number(it.view);
      }
    });

    return view;
  }

  batch = (ids: Array<number>, force?: boolean) => {
    return videoApi.batch(ids, force).then(
      action((res: IResult) => {
        if (res && res.code == 200) {
          let { data } = res;
          let map = {} as IMediumMap;
          data.forEach((it: IMedium) => {
            map[String(it.id)] = it;
          });

          this.list = {
            ...this.list,
            ...map,
          };
        }

        return this.list;
      })
    );
  };

  checkVideoExist = (id: number, force?: boolean) => {
    return new Promise((resolve) => {
      let exist = this.list[String(id)];
      if (exist && !force) {
        resolve(exist);
      } else {
        this.batch([id], force).then(() => {
          resolve(this.getVideo(id));
        });
      }
    });
  };

  @action updateVideoDetail = (id: number, detailInfo: any) => {
    let target = this.getVideo(id);

    if (target && target.type == 'live' && target.source_detail) {
      target.source_detail = {
        ...target.source_detail,
        ...detailInfo,
      };
    }
    console.log(target);
    this.list = {
      ...this.list,
      [String(id)]: target,
    };
  };

  getVideo = (id: number) => {
    return this.list[String(id)];
  };

  getLiveShowList = (
    gallery_id: string | number,
    page: number = 1,
    page_size: number = 40
  ) => {
    return videoApi.liveshowList(gallery_id, page, page_size).then(
      action((res: IResult) => {
        if (res && res.code == 200) {
          if (page == 1) {
            this.liveshow_list.items = res.data.items;
          } else {
            this.liveshow_list.items = this.liveshow_list.items.concat(
              res.data.items
            );
          }
          this.liveshow_list.total = res.data.total;
        }
      })
    );
  };

  getLiveSearch = (gallery_id: string | number, search: string) => {
    return videoApi.livesearch(gallery_id, search).then(
      action((res: IResult) => {
        if (res && res.code == 200) {
          this.liveshow_search.items = res.data;
          this.liveshow_search.total = res.data.length;
        }

        return this.liveshow_search;
      })
    );
  };

  getLiveCutList = (
    cid: string,
    videos: string[] | number[],
    gallery_id: string | number,
    page: number = 1,
    page_size: number = 40
  ) => {
    return videoApi.livecutlist(videos, gallery_id, page, page_size).then(
      action((res: IResult) => {
        if (res && res.code == 200) {
          if(!this.livecut_list[cid]) {
            this.livecut_list[cid] = {
              items:[],
              total:-1
            } as ILiveCutResult;
          }
          if (page == 1) {
            this.livecut_list[cid].items = res.data.items;
          } else {
            this.livecut_list[cid].items = this.livecut_list[cid].items.concat(
              res.data.items
            );
          }
          this.livecut_list[cid].total = res.data.total;
          this.livecut_list = {
            ...this.livecut_list
          };
        }
      })
    );
  };
 
  getLiveCutSearch = (cid:string, videos: string[] | number[], gallery_id: string | number, search: string) => {
    return videoApi.livecutsearch(videos, gallery_id, search).then(
      action((res: IResult) => {
        if(!this.livecut_search[cid]) {
          this.livecut_search[cid] = {
            items:[],
            total:-1
          } as ILiveCutResult;
        }
        if (res && res.code == 200) {
          this.livecut_search[cid].items = res.data.items;
          this.livecut_search[cid].total = res.data.total;
        }
        this.livecut_search = {
          ...this.livecut_search
        };
        return this.livecut_search[cid];
      })
    );
  };

  upLiveShowStatus = (
    gallery_id: string | number,
    id: number,
    status: string
  ) => {
    return videoApi.liveshowup(gallery_id, id, status).then(
      action((res: IResult) => {
        console.log(res);
        if (res && res.code == 200) {
          let { data } = res;
          this.liveshow_list.items = this.liveshow_list.items.map(
            (it: IMedium) => {
              if (it.id == data.id) {
                return data;
              }
              return it;
            }
          );
          this.liveshow_search.items = this.liveshow_search.items.map(
            (it: IMedium) => {
              if (it.id == data.id) {
                return data;
              }
              return it;
            }
          );
        }
        return res;
      })
    );
  };
}
